import { connect } from 'react-redux'
import { IGlobalState } from '../../../Root/store/appReducer'
import { getCurrentGoalExport } from '../../../views/Activity/store/ActivityActions'
import {
  IYumGoalRankingExportButtonDispatchProps,
  IYumGoalRankingExportButtonProps,
  YumGoalRankingExportButton,
} from './YumGoalRankingExportButton'
import { GoalId } from '../../../services/api.types'
import { getLoadingExport } from '../../../common/loading/loadingSelectors'

interface IOwnProps {
  goalId: GoalId
}

const mapStateToProps = (state: IGlobalState, ownProps: IOwnProps): IYumGoalRankingExportButtonProps => {
  const { goalId } = ownProps
  return {
    goalId,
    exportInProgress: getLoadingExport(state),
  }
}

const mapDispatchToProps: IYumGoalRankingExportButtonDispatchProps = {
  getCurrentGoalExport,
}

export default connect(mapStateToProps, mapDispatchToProps)(YumGoalRankingExportButton)
